import type { Category } from "../types/marketplace";

interface CategoryMenuProps {
  categories: Category[];
}

function CategoryMenu({ categories }: CategoryMenuProps) {
  return (
    <section className="categories-section">
      <div className="container categories-grid">
        {categories.map((category) => (
          <button
            className={`category-item ${category.active ? "active" : ""}`}
            key={category.name}
            type="button"
          >
            <span style={{ backgroundColor: category.color }}>{category.icon}</span>
            <small>{category.name}</small>
          </button>
        ))}
      </div>
    </section>
  );
}

export default CategoryMenu;
